import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';

export const query = gql`
  query GetUserBehavioralStatsAdmin($input: GetUserBehavioralStatsAdminInput!) {
    getUserBehavioralStatsAdmin(input: $input) {
      purchasePatterns {
        count
        label
      }
      purchaseTimingPatterns {
        count
        label
      }
      eventPreferences {
        count
        label
      }
      divisionPreferences {
        count
        label
      }
      seriesPreferences {
        count
        label
      }
      averageGroupSize
    }
  }
`;

export default graphql(query, {
  options: ({ match }) => {
    return {
      variables: {
        input: {
          user_id: Number(match.params.id),
        },
      },
      fetchPolicy: 'cache-and-network',
    };
  },
  name: 'behavioralData',
});
